import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  URL: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddAssetProofInput = {
  assetId: Scalars['ID']['input'];
  financingStatus?: InputMaybe<Scalars['String']['input']>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  leafposition: Scalars['Int']['input'];
  merkleroot: Scalars['String']['input'];
  movementDate?: InputMaybe<Scalars['DateTime']['input']>;
  movementQuantity?: InputMaybe<Scalars['Int']['input']>;
  movementType?: InputMaybe<MovementType>;
};

export type AddInvestmentResponse = {
  __typename?: 'AddInvestmentResponse';
  amount: Scalars['Float']['output'];
  assetfinancingpoolID: Scalars['ID']['output'];
  serviceproviderID: Scalars['ID']['output'];
  status: AssetFinancingStatus;
  totalInvestedAmount: Scalars['Float']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  housenumber: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  housenumber: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type Asset = {
  _id: Scalars['ID']['output'];
  additional?: Maybe<Array<AttributePattern>>;
  assetfinancingpool?: Maybe<AssetFinancingPool>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  financingStatus: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  idFromDocumentary: Scalars['String']['output'];
  isFinanced: Scalars['Boolean']['output'];
  proof: AssetProof;
  quantity?: Maybe<Scalars['Int']['output']>;
  sequencenumber?: Maybe<Scalars['Int']['output']>;
  serviceprovider: ServiceProviderDetails;
  serviceproviderID: Scalars['String']['output'];
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  edges: Array<AssetEdge>;
  pageInfo: PageInfo;
};

export type AssetDetails = {
  __typename?: 'AssetDetails';
  additionals: Array<AttributePattern>;
  financingDetails: Array<FinancingDetails>;
};

export type AssetEdge = {
  __typename?: 'AssetEdge';
  cursor: Scalars['String']['output'];
  node: Asset;
};

export type AssetFinancingPool = {
  __typename?: 'AssetFinancingPool';
  _id: Scalars['ID']['output'];
  activationdate?: Maybe<Scalars['DateTime']['output']>;
  amountinvested: Scalars['Int']['output'];
  assetType: AssetType;
  ceiling?: Maybe<Scalars['Int']['output']>;
  contractCID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dayslocked: Scalars['Int']['output'];
  financinglimit: Scalars['Int']['output'];
  floor?: Maybe<Scalars['Int']['output']>;
  interest: Scalars['Int']['output'];
  lockeduntil?: Maybe<Scalars['DateTime']['output']>;
  pooladdress?: Maybe<Scalars['String']['output']>;
  rewardpayoutperiod: Scalars['Int']['output'];
  serviceproviderID: Scalars['ID']['output'];
  spdetails: ServiceProviderDetails;
  status: AssetFinancingStatus;
  tokenaddress?: Maybe<Scalars['String']['output']>;
  uniqueitems?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssetFinancingPoolConnection = {
  __typename?: 'AssetFinancingPoolConnection';
  edges: Array<AssetFinancingPoolEdge>;
  pageInfo: PageInfo;
};

export type AssetFinancingPoolEdge = {
  __typename?: 'AssetFinancingPoolEdge';
  cursor: Scalars['String']['output'];
  node: AssetFinancingPool;
};

export type AssetFinancingPoolInput = {
  assetType?: InputMaybe<AssetType>;
  ceiling?: InputMaybe<Scalars['Int']['input']>;
  contractCID?: InputMaybe<Scalars['String']['input']>;
  dayslocked: Scalars['Int']['input'];
  financinglimit: Scalars['Int']['input'];
  floor?: InputMaybe<Scalars['Int']['input']>;
  interest: Scalars['Int']['input'];
  rewardpayoutperiod: Scalars['Int']['input'];
  uniqueitems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetFinancingRound = {
  __typename?: 'AssetFinancingRound';
  _id: Scalars['ID']['output'];
  amountFinanced: Scalars['Float']['output'];
  amountNotFinanced: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  inventoryBought?: Maybe<Scalars['Float']['output']>;
  inventorySold?: Maybe<Scalars['Float']['output']>;
  serviceproviderID: Scalars['ID']['output'];
  spdetails: ServiceProviderDetails;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssetFinancingRoundConnection = {
  __typename?: 'AssetFinancingRoundConnection';
  edges: Array<AssetFinancingRoundEdge>;
  pageInfo: PageInfo;
};

export type AssetFinancingRoundEdge = {
  __typename?: 'AssetFinancingRoundEdge';
  cursor: Scalars['String']['output'];
  node: AssetFinancingRound;
};

export type AssetFinancingRoundInput = {
  amountFinanced: Scalars['Float']['input'];
  amountNotFinanced: Scalars['Float']['input'];
  inventoryBought?: InputMaybe<Scalars['Float']['input']>;
  inventorySold?: InputMaybe<Scalars['Float']['input']>;
};

export enum AssetFinancingStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Onboarding = 'ONBOARDING',
  Open = 'OPEN'
}

export type AssetHashData = {
  __typename?: 'AssetHashData';
  customerID?: Maybe<Scalars['ID']['output']>;
  date: Scalars['DateTime']['output'];
  idFromDocumentary: Scalars['String']['output'];
  leafposition?: Maybe<Scalars['Int']['output']>;
  movementQuantity?: Maybe<Scalars['Int']['output']>;
  movementType?: Maybe<MovementType>;
  serviceProviderId: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
};

export type AssetHashDataConnection = {
  __typename?: 'AssetHashDataConnection';
  data: Array<AssetHashData>;
  pageInfo: PageInfo;
};

export type AssetProof = {
  __typename?: 'AssetProof';
  assetID?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financingStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  leafposition: Scalars['Int']['output'];
  merkleroot: Scalars['String']['output'];
  movementDate?: Maybe<Scalars['DateTime']['output']>;
  movementQuantity?: Maybe<Scalars['Int']['output']>;
  movementType?: Maybe<MovementType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AssetProofInput = {
  financingStatus?: InputMaybe<Scalars['String']['input']>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  leafposition: Scalars['Int']['input'];
  merkleroot: Scalars['String']['input'];
  movementDate?: InputMaybe<Scalars['DateTime']['input']>;
  movementQuantity?: InputMaybe<Scalars['Int']['input']>;
  movementType?: InputMaybe<MovementType>;
};

export enum AssetType {
  Inventory = 'INVENTORY',
  Receivable = 'RECEIVABLE'
}

export type AttributePattern = {
  __typename?: 'AttributePattern';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttributePatternInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  beneficiaryID?: Maybe<Scalars['ID']['output']>;
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  name: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type BankAccountInput = {
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Company = {
  _id: Scalars['ID']['output'];
  address: Address;
  bankaccount: BankAccount;
  companytype: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['PhoneNumber']['output'];
  publickey: Scalars['String']['output'];
  referencenumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatnumber: Scalars['String']['output'];
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges: Array<CompanyEdge>;
  pageInfo: PageInfo;
};

export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  description?: Maybe<Scalars['String']['output']>;
  foundingyear?: Maybe<Scalars['Int']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  webpresence?: Maybe<WebPresence>;
  yearlyrevenue?: Maybe<Scalars['Int']['output']>;
};

export type CompanyDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  foundingyear?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  yearlyrevenue?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

export enum CompanyType {
  Customer = 'CUSTOMER',
  Financier = 'FINANCIER',
  Serviceprovider = 'SERVICEPROVIDER'
}

export type CreateAssetInput = {
  additional?: InputMaybe<Array<InputMaybe<AttributePatternInput>>>;
  assetfinancingpoolID: Scalars['String']['input'];
  customerID?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  financingStatus: Scalars['String']['input'];
  idFromDocumentary: Scalars['String']['input'];
  isFinanced: Scalars['Boolean']['input'];
  proof: AssetProofInput;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  serviceproviderID: Scalars['String']['input'];
  shopURL?: InputMaybe<Scalars['String']['input']>;
  type: AssetType;
  value: Scalars['Float']['input'];
};

export type CreateCompanyInput = {
  address: AddressInput;
  bankaccount: BankAccountInput;
  companytype: CompanyType;
  customerinput?: InputMaybe<CreateCustomerInput>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  serviceproviderinput?: InputMaybe<CreateServiceProviderInput>;
  vatnumber: Scalars['String']['input'];
};

export type CreateCreditLimitRequestInput = {
  customerID: Scalars['String']['input'];
  reasonForRequest: Scalars['String']['input'];
  requestedAmount: Scalars['Float']['input'];
  serviceproviderID: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  documentaryID: Scalars['String']['input'];
  legalEntityIdentifier: Scalars['String']['input'];
  serviceproviderID: Scalars['String']['input'];
};

export type CreateInvoiceInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customerID: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  invoiceNumber: Scalars['String']['input'];
  serviceproviderID: Scalars['String']['input'];
  status: InvoiceStatus;
  totalamount: Scalars['Float']['input'];
  vatamount: Scalars['Float']['input'];
  vatrate: Scalars['Float']['input'];
};

export type CreateIsCustomerOfInput = {
  customerID: Scalars['String']['input'];
  idFromDocumentary: Scalars['String']['input'];
  serviceproviderID: Scalars['String']['input'];
};

export type CreateManyAssetsReturnType = {
  __typename?: 'CreateManyAssetsReturnType';
  created: Scalars['Boolean']['output'];
  idFromDocumentary: Scalars['String']['output'];
};

export type CreateServiceProviderInput = {
  assetdocumentary: DocumentaryInput;
  assetfinancingpool: AssetFinancingPoolInput;
  companydetails?: InputMaybe<CompanyDetailsInput>;
  invoicedocumentary: DocumentaryInput;
};

export type CreateUserInput = {
  employerID?: InputMaybe<Scalars['ID']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  mail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRole;
};

export type CreditLimitRequest = {
  __typename?: 'CreditLimitRequest';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerID: Scalars['String']['output'];
  reasonForDenial?: Maybe<Scalars['String']['output']>;
  reasonForRequest: Scalars['String']['output'];
  requestedAmount: Scalars['Float']['output'];
  serviceprovider: ServiceProvider;
  serviceproviderID: Scalars['String']['output'];
  status: CreditLimitRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreditLimitRequestConnection = {
  __typename?: 'CreditLimitRequestConnection';
  edges: Array<CreditLimitRequestEdge>;
  pageInfo: PageInfo;
};

export type CreditLimitRequestEdge = {
  __typename?: 'CreditLimitRequestEdge';
  cursor: Scalars['String']['output'];
  node: CreditLimitRequest;
};

export enum CreditLimitRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type Customer = Company & {
  __typename?: 'Customer';
  _id: Scalars['ID']['output'];
  address: Address;
  bankaccount: BankAccount;
  companytype: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  isCustomerOf: Array<IsCustomerOf>;
  legalEntityIdentifier: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['PhoneNumber']['output'];
  publickey: Scalars['String']['output'];
  referencenumber: Scalars['String']['output'];
  status: CustomerStatus;
  updatedAt: Scalars['DateTime']['output'];
  vatnumber: Scalars['String']['output'];
};

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  edges: Array<CustomerEdge>;
  pageInfo: PageInfo;
};

export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  cursor: Scalars['String']['output'];
  node: CustomerOnServiceProvider;
};

export type CustomerOnAsset = {
  __typename?: 'CustomerOnAsset';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publickey: Scalars['String']['output'];
};

export type CustomerOnServiceProvider = {
  __typename?: 'CustomerOnServiceProvider';
  _id: Scalars['ID']['output'];
  companytype: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  idFromDocumentary: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publickey: Scalars['String']['output'];
  status: CustomerStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type DeployedAfp = {
  __typename?: 'DeployedAFP';
  pooladdress: Scalars['String']['output'];
  tokenaddress: Scalars['String']['output'];
};

export type Developer = User & {
  __typename?: 'Developer';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  allowMails: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  mail: Scalars['EmailAddress']['output'];
  role: UserRole;
  usertype: UserType;
};

export type Documentary = {
  __typename?: 'Documentary';
  authEndpoint: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  endpointType: EndpointType;
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type DocumentaryInput = {
  authendpoint: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  endpointType: EndpointType;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type EditAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  housenumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type EditAssetFinancingPoolInput = {
  assetType?: InputMaybe<AssetType>;
  ceiling?: InputMaybe<Scalars['Int']['input']>;
  contractCID?: InputMaybe<Scalars['String']['input']>;
  dayslocked?: InputMaybe<Scalars['Int']['input']>;
  financinglimit?: InputMaybe<Scalars['Int']['input']>;
  floor?: InputMaybe<Scalars['Int']['input']>;
  interest?: InputMaybe<Scalars['Int']['input']>;
  rewardpayoutperiod?: InputMaybe<Scalars['Int']['input']>;
  uniqueitems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditBankAccountInput = {
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
};

export type EditCompanyInput = {
  address?: InputMaybe<EditAddressInput>;
  bankaccount?: InputMaybe<EditBankAccountInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publickey?: InputMaybe<Scalars['String']['input']>;
  serviceproviderinput?: InputMaybe<EditServiceProviderInput>;
  vatnumber?: InputMaybe<Scalars['String']['input']>;
};

export type EditCreditLimitRequestInput = {
  reasonForDenial?: InputMaybe<Scalars['String']['input']>;
  reasonForRequest?: InputMaybe<Scalars['String']['input']>;
  requestedAmount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<CreditLimitRequestStatus>;
};

export type EditDocumentaryInput = {
  authendpoint?: InputMaybe<Scalars['URL']['input']>;
  endpoint?: InputMaybe<Scalars['URL']['input']>;
  endpointType?: InputMaybe<EndpointType>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type EditInvoiceInput = {
  status: InvoiceStatus;
};

export type EditInvoicePaymentsInput = {
  ids: Array<Scalars['ID']['input']>;
  mintToPoolStatus?: InputMaybe<UpdatePoolSpStatus>;
  mintToSpStatus?: InputMaybe<UpdatePoolSpStatus>;
  status: InvoicePaymentStatus;
};

export type EditServiceProviderInput = {
  assetdocumentary?: InputMaybe<EditDocumentaryInput>;
  companydetails?: InputMaybe<CompanyDetailsInput>;
  invoicedocumentary?: InputMaybe<EditDocumentaryInput>;
};

export type EditTokenTransactionInput = {
  bankTransactionID?: InputMaybe<Scalars['String']['input']>;
  banktransferdate?: InputMaybe<Scalars['DateTime']['input']>;
  reasonForFailure?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TokenTransactionStatus>;
  tokentransferdate?: InputMaybe<Scalars['DateTime']['input']>;
  txhash?: InputMaybe<Scalars['String']['input']>;
};

export type EditUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowMails?: InputMaybe<Scalars['Boolean']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export type Employee = User & {
  __typename?: 'Employee';
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  allowMails: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  employer: Company;
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  mail: Scalars['EmailAddress']['output'];
  role: UserRole;
  usertype: UserType;
};

export enum EndpointType {
  Coredinate = 'Coredinate',
  Pop = 'POP',
  Plentymarkets = 'Plentymarkets'
}

export type FalseAsset = {
  __typename?: 'FalseAsset';
  idFromDocumentary: Scalars['String']['output'];
};

export type Financier = Company & {
  __typename?: 'Financier';
  _id: Scalars['ID']['output'];
  address: Address;
  availableWithdrawals: Array<Withdrawal>;
  averageInterestRate: Scalars['Float']['output'];
  bankaccount: BankAccount;
  companytype: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  currentWorthIncludingInterest: Scalars['Float']['output'];
  investments: Array<Investment>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextWithdrawal?: Maybe<Withdrawal>;
  phone: Scalars['PhoneNumber']['output'];
  publickey: Scalars['String']['output'];
  referencenumber: Scalars['String']['output'];
  totalInvestedAmount: Scalars['Float']['output'];
  totalInvestedAmountInclInterest: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatnumber: Scalars['String']['output'];
};

export type FinancingDetails = {
  __typename?: 'FinancingDetails';
  createdAt: Scalars['DateTime']['output'];
  financingStatus?: Maybe<Scalars['String']['output']>;
  isFinanced?: Maybe<Scalars['Boolean']['output']>;
  movementDate?: Maybe<Scalars['DateTime']['output']>;
  movementQuantity?: Maybe<Scalars['Int']['output']>;
  movementType?: Maybe<MovementType>;
};

export type FinancingUpdate = {
  assetId: Scalars['ID']['input'];
  financingStatus: Scalars['String']['input'];
  isFinanced: Scalars['Boolean']['input'];
};

export type InMovementType = {
  __typename?: 'InMovementType';
  falseAssets: Array<FalseAsset>;
  knownInMovements: Array<InventoryAsset>;
};

export type InventoryAsset = Asset & {
  __typename?: 'InventoryAsset';
  _id: Scalars['ID']['output'];
  additional?: Maybe<Array<AttributePattern>>;
  assetfinancingpool?: Maybe<AssetFinancingPool>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  financingStatus: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  idFromDocumentary: Scalars['String']['output'];
  isCollateral: Scalars['Boolean']['output'];
  isFinanced: Scalars['Boolean']['output'];
  proof: AssetProof;
  quantity?: Maybe<Scalars['Int']['output']>;
  sequencenumber?: Maybe<Scalars['Int']['output']>;
  serviceprovider: ServiceProviderDetails;
  serviceproviderID: Scalars['String']['output'];
  shopURL: Scalars['String']['output'];
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type Investment = {
  __typename?: 'Investment';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  assetfinancingpool: AssetFinancingPool;
  assetfinancingpoolID: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentNumberOfInterestWithdrawals: Scalars['Int']['output'];
  financierID: Scalars['ID']['output'];
  maximumNumberOfInterestWithdrawals: Scalars['Int']['output'];
  serviceproviderID: Scalars['ID']['output'];
  serviceproviderName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvestmentConnection = {
  __typename?: 'InvestmentConnection';
  edges: Array<InvestmentEdge>;
  pageInfo: PageInfo;
};

export type InvestmentEdge = {
  __typename?: 'InvestmentEdge';
  cursor: Scalars['String']['output'];
  node: Investment;
};

export type InvestmentInput = {
  amount: Scalars['Float']['input'];
  assetfinancingpoolID: Scalars['ID']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['ID']['output'];
  assets: Array<Asset>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerID: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  serviceprovider: ServiceProvider;
  serviceproviderID: Scalars['String']['output'];
  status: InvoiceStatus;
  totalamount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatamount: Scalars['Float']['output'];
  vatrate: Scalars['Float']['output'];
};

export enum InvoicePaymentStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  SendToPu = 'SEND_TO_PU'
}

export enum InvoiceStatus {
  Defaulted = 'DEFAULTED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING',
  Warned = 'WARNED'
}

export type IsCustomerOf = {
  __typename?: 'IsCustomerOf';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerID: Scalars['String']['output'];
  idFromDocumentary: Scalars['String']['output'];
  serviceproviderID: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type KnownCustomer = {
  __typename?: 'KnownCustomer';
  knownToDB: Array<KnownCustomerData>;
  knownToSP: Array<KnownCustomerData>;
};

export type KnownCustomerData = {
  __typename?: 'KnownCustomerData';
  customerId: Scalars['ID']['output'];
  customerIdFromDocumentary?: Maybe<Scalars['String']['output']>;
  lei: Scalars['String']['output'];
  publickey: Scalars['String']['output'];
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  token: Scalars['String']['output'];
  user: User;
};

export enum MovementType {
  In = 'IN',
  Out = 'OUT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAssetFinancingPool: AssetFinancingPool;
  addAssetFinancingRound: Scalars['Boolean']['output'];
  addAssetProofs: Scalars['Int']['output'];
  addInvestment: AddInvestmentResponse;
  addTokenTransaction: TokenTransaction;
  changeLogo: Scalars['String']['output'];
  createAsset: Asset;
  createCompany: Scalars['String']['output'];
  createCreditLimitRequest: CreditLimitRequest;
  createInvoice: Invoice;
  createIsCustomerOf: IsCustomerOf;
  createMultipleAssets: Scalars['Int']['output'];
  createMultipleInvoices: Array<Scalars['ID']['output']>;
  createUser: User;
  deleteCompany: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deployAssetFinancingPoolContract: DeployedAfp;
  editAssetFinancingPool: AssetFinancingPool;
  editCompany: Scalars['Boolean']['output'];
  editCreditLimitRequest: CreditLimitRequest;
  editInvoice: Scalars['Boolean']['output'];
  editInvoicePayments: Scalars['Boolean']['output'];
  editPassword: Scalars['Boolean']['output'];
  editTokenTransaction: Scalars['Boolean']['output'];
  editUser: Scalars['Boolean']['output'];
  executeWithdrawalOnInvestment: Scalars['Boolean']['output'];
  forgotPassword: Scalars['Boolean']['output'];
  setPassword: Scalars['Boolean']['output'];
  updateAssetQuantity: Scalars['Boolean']['output'];
  updateFinancingStatus: Scalars['Boolean']['output'];
};


export type MutationAddAssetFinancingPoolArgs = {
  ID: Scalars['ID']['input'];
  assetFinancingPoolInput: AssetFinancingPoolInput;
};


export type MutationAddAssetFinancingRoundArgs = {
  ID: Scalars['ID']['input'];
  assetFinancingRoundInput: AssetFinancingRoundInput;
};


export type MutationAddAssetProofsArgs = {
  assetProofInput: Array<AddAssetProofInput>;
};


export type MutationAddInvestmentArgs = {
  ID: Scalars['ID']['input'];
  investmentInput: InvestmentInput;
};


export type MutationAddTokenTransactionArgs = {
  ID: Scalars['ID']['input'];
  tokenTransactionInput: TokenTransactionInput;
};


export type MutationChangeLogoArgs = {
  ID: Scalars['ID']['input'];
  newPicture?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateAssetArgs = {
  assetInput: CreateAssetInput;
};


export type MutationCreateCompanyArgs = {
  companyInput: CreateCompanyInput;
};


export type MutationCreateCreditLimitRequestArgs = {
  creditLimitRequestInput: CreateCreditLimitRequestInput;
};


export type MutationCreateInvoiceArgs = {
  invoiceInput: CreateInvoiceInput;
};


export type MutationCreateIsCustomerOfArgs = {
  input: CreateIsCustomerOfInput;
};


export type MutationCreateMultipleAssetsArgs = {
  assetsInput: Array<CreateAssetInput>;
};


export type MutationCreateMultipleInvoicesArgs = {
  invoicesInput: Array<CreateInvoiceInput>;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationDeleteCompanyArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeployAssetFinancingPoolContractArgs = {
  serviceProviderID: Scalars['ID']['input'];
};


export type MutationEditAssetFinancingPoolArgs = {
  ID: Scalars['ID']['input'];
  assetFinancingPoolInput: EditAssetFinancingPoolInput;
};


export type MutationEditCompanyArgs = {
  ID: Scalars['ID']['input'];
  companyInput: EditCompanyInput;
};


export type MutationEditCreditLimitRequestArgs = {
  ID: Scalars['ID']['input'];
  creditLimitRequestInput: EditCreditLimitRequestInput;
};


export type MutationEditInvoiceArgs = {
  ID: Scalars['ID']['input'];
  invoiceInput: EditInvoiceInput;
};


export type MutationEditInvoicePaymentsArgs = {
  input: EditInvoicePaymentsInput;
};


export type MutationEditPasswordArgs = {
  ID: Scalars['ID']['input'];
  passwordInput: PasswordInput;
};


export type MutationEditTokenTransactionArgs = {
  ID: Scalars['ID']['input'];
  tokenTransactionInput: EditTokenTransactionInput;
};


export type MutationEditUserArgs = {
  ID: Scalars['ID']['input'];
  userInput: EditUserInput;
};


export type MutationExecuteWithdrawalOnInvestmentArgs = {
  ID: Scalars['ID']['input'];
  withdrawalType: WithdrawalType;
};


export type MutationForgotPasswordArgs = {
  mail: Scalars['String']['input'];
};


export type MutationSetPasswordArgs = {
  ID: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateAssetQuantityArgs = {
  updateQuantityInput: Array<UpdateQuantityInput>;
};


export type MutationUpdateFinancingStatusArgs = {
  financingUpdate: Array<FinancingUpdate>;
};

export type OpenForFinancing = {
  __typename?: 'OpenForFinancing';
  _id: Scalars['ID']['output'];
  assetfinancingpool: AssetFinancingPool;
  companydetails?: Maybe<CompanyDetails>;
  name: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  company: Company;
  fetchInMovements: InMovementType;
  fetchKnownCustomers: KnownCustomer;
  fetchOutMovements: Array<InventoryAsset>;
  fetchRetryAssets: Array<RetriableAsset>;
  fetchRetryCustomersById: Array<RetryCustomer>;
  getAssetDetailsByID: AssetDetails;
  getOffChainCodedTerms: Scalars['String']['output'];
  getServiceProviderDetailsByID: ServiceProviderDetails;
  invoice: Invoice;
  loginUser: LoginUserResponse;
  paginatedAssetFinancingPools: AssetFinancingPoolConnection;
  paginatedAssetFinancingRounds: AssetFinancingRoundConnection;
  paginatedAssetHashData: AssetHashDataConnection;
  paginatedAssets: AssetConnection;
  paginatedCompanies: CompanyConnection;
  paginatedCreditLimitRequests: CreditLimitRequestConnection;
  paginatedCustomers: CustomerConnection;
  paginatedInvestments: InvestmentConnection;
  paginatedTokenTransactions: TokenTransactionConnection;
  paginatedUsers: UserConnection;
};


export type QueryCompanyArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryFetchInMovementsArgs = {
  assetfinancingpoolID: Scalars['ID']['input'];
  idFromDocumentaries: Array<Scalars['String']['input']>;
};


export type QueryFetchKnownCustomersArgs = {
  customersLeis: Array<Scalars['String']['input']>;
  serviceproviderID: Scalars['String']['input'];
};


export type QueryFetchOutMovementsArgs = {
  assetfinancingpoolID: Scalars['ID']['input'];
  idFromDocumentaries: Array<Scalars['String']['input']>;
};


export type QueryFetchRetryAssetsArgs = {
  serviceProviderID: Scalars['ID']['input'];
};


export type QueryFetchRetryCustomersByIdArgs = {
  idFromDocumentaries?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceProviderId: Scalars['String']['input'];
};


export type QueryGetAssetDetailsByIdArgs = {
  assetID: Scalars['ID']['input'];
};


export type QueryGetServiceProviderDetailsByIdArgs = {
  serviceproviderID: Scalars['String']['input'];
};


export type QueryInvoiceArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryLoginUserArgs = {
  mail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaginatedAssetFinancingPoolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyname?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  status?: InputMaybe<AssetFinancingStatus>;
};


export type QueryPaginatedAssetFinancingRoundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  poolID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaginatedAssetHashDataArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  merkleroot: Scalars['String']['input'];
};


export type QueryPaginatedAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetfinancingpoolID?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPaginatedCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  companytype?: InputMaybe<CompanyType>;
  first: Scalars['Int']['input'];
  status?: InputMaybe<AssetFinancingStatus>;
};


export type QueryPaginatedCreditLimitRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  customerID?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CreditLimitRequestStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryPaginatedCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatedInvestmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  status?: InputMaybe<AssetFinancingStatus>;
};


export type QueryPaginatedTokenTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  status?: InputMaybe<TokenTransactionStatus>;
  type?: InputMaybe<TokenTransactionType>;
};


export type QueryPaginatedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ReceivableAsset = Asset & {
  __typename?: 'ReceivableAsset';
  _id: Scalars['ID']['output'];
  additional?: Maybe<Array<AttributePattern>>;
  assetfinancingpool?: Maybe<AssetFinancingPool>;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerOnAsset;
  customerID: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  financingStatus: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  idFromDocumentary: Scalars['String']['output'];
  isFinanced: Scalars['Boolean']['output'];
  proof: AssetProof;
  quantity?: Maybe<Scalars['Int']['output']>;
  sequencenumber?: Maybe<Scalars['Int']['output']>;
  serviceprovider: ServiceProviderDetails;
  serviceproviderID: Scalars['String']['output'];
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type RetriableAsset = {
  __typename?: 'RetriableAsset';
  assetId: Scalars['String']['output'];
  customerIdFromDocumentary: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  idFromDocumentary: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RetryCustomer = {
  __typename?: 'RetryCustomer';
  customerIdFromDocumentary: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publickey: Scalars['String']['output'];
};

export type ServiceProvider = Company & {
  __typename?: 'ServiceProvider';
  _id: Scalars['ID']['output'];
  address: Address;
  assetdocumentary: Documentary;
  assetfinancingpool: AssetFinancingPool;
  bankaccount: BankAccount;
  companydetails?: Maybe<CompanyDetails>;
  companytype: CompanyType;
  createdAt: Scalars['DateTime']['output'];
  customers: Array<CustomerOnServiceProvider>;
  investments: Array<Investment>;
  invoicedocumentary: Documentary;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['PhoneNumber']['output'];
  publickey: Scalars['String']['output'];
  referencenumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users: Array<UserOnSp>;
  vatnumber: Scalars['String']['output'];
};

export type ServiceProviderDetails = {
  __typename?: 'ServiceProviderDetails';
  _id: Scalars['ID']['output'];
  assettype?: Maybe<Scalars['String']['output']>;
  companydetails?: Maybe<CompanyDetails>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Subscribe to credit limit request creation event.
   * Parameter serviceProviderId is used for filtering events
   * by service provider. In case of an admin user it is optional,
   * and in case of a service provider user it is mandatory.
   */
  creditLimitRequestCreated?: Maybe<CreditLimitRequest>;
  /**
   * Subscribe to credit limit request editing event.
   * Parameter serviceProviderId is used for filtering events
   * by service provider. In case of an admin user it is optional,
   * and in case of a service provider user it is mandatory.
   */
  creditLimitRequestEdited?: Maybe<CreditLimitRequest>;
};


export type SubscriptionCreditLimitRequestCreatedArgs = {
  serviceProviderId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionCreditLimitRequestEditedArgs = {
  serviceProviderId?: InputMaybe<Scalars['ID']['input']>;
};

export type TokenTransaction = {
  __typename?: 'TokenTransaction';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  banktransferdate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  reasonForFailure?: Maybe<Scalars['String']['output']>;
  referencenumber?: Maybe<Scalars['String']['output']>;
  status: TokenTransactionStatus;
  tokentransferdate?: Maybe<Scalars['DateTime']['output']>;
  txhash?: Maybe<Scalars['String']['output']>;
  type: TokenTransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TokenTransactionConnection = {
  __typename?: 'TokenTransactionConnection';
  edges: Array<TokenTransactionEdge>;
  pageInfo: PageInfo;
};

export type TokenTransactionEdge = {
  __typename?: 'TokenTransactionEdge';
  cursor: Scalars['String']['output'];
  node: TokenTransaction;
};

export type TokenTransactionInput = {
  amount: Scalars['Float']['input'];
};

export enum TokenTransactionStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum TokenTransactionType {
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum UpdatePoolSpStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type UpdateQuantityInput = {
  assetId: Scalars['ID']['input'];
  movementQuantity: Scalars['Int']['input'];
  movementType: MovementType;
};

export type User = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  allowMails: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  mail: Scalars['EmailAddress']['output'];
  role: UserRole;
  usertype: UserType;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserOnSp = {
  __typename?: 'UserOnSP';
  mail: Scalars['String']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Superuser = 'SUPERUSER',
  User = 'USER'
}

export enum UserType {
  Developer = 'DEVELOPER',
  Employee = 'EMPLOYEE',
  Financier = 'FINANCIER'
}

export type WebPresence = {
  __typename?: 'WebPresence';
  facebook?: Maybe<Scalars['URL']['output']>;
  linkedin?: Maybe<Scalars['URL']['output']>;
  twitter?: Maybe<Scalars['URL']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  investmentID: Scalars['ID']['output'];
  spid: Scalars['ID']['output'];
  type: WithdrawalType;
};

export enum WithdrawalType {
  Interest = 'INTEREST',
  Investment = 'INVESTMENT'
}

type CompanyDetails_Customer_Fragment = { __typename?: 'Customer', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

type CompanyDetails_Financier_Fragment = { __typename?: 'Financier', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

type CompanyDetails_ServiceProvider_Fragment = { __typename?: 'ServiceProvider', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

export type CompanyDetailsFragment = CompanyDetails_Customer_Fragment | CompanyDetails_Financier_Fragment | CompanyDetails_ServiceProvider_Fragment;

type BankAccount_Customer_Fragment = { __typename?: 'Customer', bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

type BankAccount_Financier_Fragment = { __typename?: 'Financier', bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

type BankAccount_ServiceProvider_Fragment = { __typename?: 'ServiceProvider', bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean } };

export type BankAccountFragment = BankAccount_Customer_Fragment | BankAccount_Financier_Fragment | BankAccount_ServiceProvider_Fragment;

export type UpdatedServiceProviderFragment = { __typename?: 'ServiceProvider', _id: string, assetfinancingpool: { __typename?: 'AssetFinancingPool', _id: string } };

type Logo_Customer_Fragment = { __typename?: 'Customer', logo?: string | null };

type Logo_Financier_Fragment = { __typename?: 'Financier', logo?: string | null };

type Logo_ServiceProvider_Fragment = { __typename?: 'ServiceProvider', logo?: string | null };

export type LogoFragment = Logo_Customer_Fragment | Logo_Financier_Fragment | Logo_ServiceProvider_Fragment;

export type FinancierDetailsFragment = { __typename?: 'Financier', _id: string, totalInvestedAmount: number, averageInterestRate: number, currentWorthIncludingInterest: number, totalInvestedAmountInclInterest: number, nextWithdrawal?: { __typename?: 'Withdrawal', investmentID: string, date: any, amount: number, type: WithdrawalType, spid: string } | null, availableWithdrawals: Array<{ __typename?: 'Withdrawal', investmentID: string, date: any, amount: number, type: WithdrawalType, spid: string }>, investments: Array<{ __typename?: 'Investment', _id: string, amount: number, serviceproviderName: string, serviceproviderID: string, createdAt: any, updatedAt: any, assetfinancingpool: { __typename?: 'AssetFinancingPool', status: AssetFinancingStatus, pooladdress?: string | null, assetType: AssetType, contractCID?: string | null } }> };

export type FinancierDetailsLiteFragment = { __typename?: 'Financier', totalInvestedAmount: number, averageInterestRate: number, currentWorthIncludingInterest: number, totalInvestedAmountInclInterest: number };

export type ServiceProviderDataFragment = { __typename?: 'ServiceProvider', name: string, assetfinancingpool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, uniqueitems?: boolean | null, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null } };

export type ServiceProviderDetailsFragment = { __typename?: 'ServiceProviderDetails', name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null };

export type CompanyDetailsOnlyFragment = { __typename?: 'ServiceProvider', companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null };

type CompanyAddress_Customer_Fragment = { __typename?: 'Customer', address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string } };

type CompanyAddress_Financier_Fragment = { __typename?: 'Financier', address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string } };

type CompanyAddress_ServiceProvider_Fragment = { __typename?: 'ServiceProvider', address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string } };

export type CompanyAddressFragment = CompanyAddress_Customer_Fragment | CompanyAddress_Financier_Fragment | CompanyAddress_ServiceProvider_Fragment;

export type CreditLimitRequestFragment = { __typename?: 'CreditLimitRequest', _id: string, serviceproviderID: string, customerID: string, requestedAmount: number, reasonForRequest: string, reasonForDenial?: string | null, status: CreditLimitRequestStatus, updatedAt: any, createdAt: any, serviceprovider: { __typename?: 'ServiceProvider', name: string }, customer: { __typename?: 'Customer', name: string } };

type CompanyPublicKey_Customer_Fragment = { __typename?: 'Customer', publickey: string };

type CompanyPublicKey_Financier_Fragment = { __typename?: 'Financier', publickey: string };

type CompanyPublicKey_ServiceProvider_Fragment = { __typename?: 'ServiceProvider', publickey: string };

export type CompanyPublicKeyFragment = CompanyPublicKey_Customer_Fragment | CompanyPublicKey_Financier_Fragment | CompanyPublicKey_ServiceProvider_Fragment;

export type EmployeeDetailsFragment = { __typename: 'Employee', _id: string, active: boolean, firstname: string, lastname: string, mail: any, role: UserRole, usertype: UserType, allowMails: boolean, employer: { __typename: 'Customer', _id: string, name: string } | { __typename: 'Financier', _id: string, name: string } | { __typename: 'ServiceProvider', _id: string, name: string } };

export type DeveloperDetailsFragment = { __typename: 'Developer', _id: string, active: boolean, firstname: string, lastname: string, mail: any, role: UserRole, usertype: UserType, allowMails: boolean };

export type AssetFinancingPoolFragment = { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null, serviceproviderID: string };

export type AfpInvestFieldsFragment = { __typename?: 'AssetFinancingPool', amountinvested: number, status: AssetFinancingStatus };

export type AssetFinancingPoolMoreFragment = { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null, serviceproviderID: string, createdAt: any, updatedAt: any, spdetails: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } };

export type ContractAddressesFragment = { __typename?: 'AssetFinancingPool', pooladdress?: string | null, tokenaddress?: string | null, status: AssetFinancingStatus };

export type InvestmentFieldsFragment = { __typename?: 'Investment', serviceproviderID: string, amount: number };

export type CreateUserMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'Developer', _id: string, firstname: string, lastname: string, usertype: UserType, mail: any, role: UserRole, active: boolean } | { __typename?: 'Employee', _id: string, firstname: string, lastname: string, usertype: UserType, mail: any, role: UserRole, active: boolean, employer: { __typename?: 'Customer', _id: string, name: string } | { __typename?: 'Financier', _id: string, name: string } | { __typename?: 'ServiceProvider', _id: string, name: string } } };

export type CreateCompanyMutationVariables = Exact<{
  companyInput: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: string };

export type AddInvestmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  investmentInput: InvestmentInput;
}>;


export type AddInvestmentMutation = { __typename?: 'Mutation', addInvestment: { __typename?: 'AddInvestmentResponse', serviceproviderID: string, assetfinancingpoolID: string, amount: number, status: AssetFinancingStatus, totalInvestedAmount: number } };

export type EditUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userInput: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser: boolean };

export type EditPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  passwordInput: PasswordInput;
}>;


export type EditPasswordMutation = { __typename?: 'Mutation', editPassword: boolean };

export type EditCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyInput: EditCompanyInput;
}>;


export type EditCompanyMutation = { __typename?: 'Mutation', editCompany: boolean };

export type ChangeLogoMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newPicture?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type ChangeLogoMutation = { __typename?: 'Mutation', changeLogo: string };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type DeployAssetFinancingPoolContractMutationVariables = Exact<{
  serviceProviderId: Scalars['ID']['input'];
}>;


export type DeployAssetFinancingPoolContractMutation = { __typename?: 'Mutation', deployAssetFinancingPoolContract: { __typename?: 'DeployedAFP', pooladdress: string, tokenaddress: string } };

export type AddTokenTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tokenTransactionInput: TokenTransactionInput;
}>;


export type AddTokenTransactionMutation = { __typename?: 'Mutation', addTokenTransaction: { __typename?: 'TokenTransaction', _id: string, amount: number, type: TokenTransactionType, status: TokenTransactionStatus, txhash?: string | null, referencenumber?: string | null, tokentransferdate?: any | null, banktransferdate?: any | null, reasonForFailure?: string | null, createdAt: any, updatedAt: any } };

export type CreateCreditLimitRequestMutationVariables = Exact<{
  creditLimitRequestInput: CreateCreditLimitRequestInput;
}>;


export type CreateCreditLimitRequestMutation = { __typename?: 'Mutation', createCreditLimitRequest: { __typename?: 'CreditLimitRequest', _id: string, serviceproviderID: string, customerID: string, requestedAmount: number, reasonForRequest: string, reasonForDenial?: string | null, status: CreditLimitRequestStatus, updatedAt: any, createdAt: any, serviceprovider: { __typename?: 'ServiceProvider', name: string }, customer: { __typename?: 'Customer', name: string } } };

export type EditCreditLimitRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  creditLimitRequestInput: EditCreditLimitRequestInput;
}>;


export type EditCreditLimitRequestMutation = { __typename?: 'Mutation', editCreditLimitRequest: { __typename?: 'CreditLimitRequest', _id: string, status: CreditLimitRequestStatus } };

export type ExecuteWithdrawalOnInvestmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withdrawalType: WithdrawalType;
}>;


export type ExecuteWithdrawalOnInvestmentMutation = { __typename?: 'Mutation', executeWithdrawalOnInvestment: boolean };

export type EditAssetFinancingPoolMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assetFinancingPoolInput: EditAssetFinancingPoolInput;
}>;


export type EditAssetFinancingPoolMutation = { __typename?: 'Mutation', editAssetFinancingPool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, serviceproviderID: string, uniqueitems?: boolean | null } };

export type AddAssetFinancingPoolMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assetFinancingPoolInput: AssetFinancingPoolInput;
}>;


export type AddAssetFinancingPoolMutation = { __typename?: 'Mutation', addAssetFinancingPool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, serviceproviderID: string, uniqueitems?: boolean | null } };

export type SetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  mail: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type LoginUserQueryVariables = Exact<{
  mail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LoginUserQuery = { __typename?: 'Query', loginUser: { __typename?: 'LoginUserResponse', token: string, user: { __typename: 'Developer', _id: string, active: boolean, firstname: string, lastname: string, mail: any, role: UserRole, usertype: UserType, allowMails: boolean } | { __typename: 'Employee', _id: string, active: boolean, firstname: string, lastname: string, mail: any, role: UserRole, usertype: UserType, allowMails: boolean, employer: { __typename: 'Customer', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean, beneficiaryID?: string | null } } | { __typename: 'Financier', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, totalInvestedAmount: number, averageInterestRate: number, currentWorthIncludingInterest: number, totalInvestedAmountInclInterest: number, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean, beneficiaryID?: string | null }, nextWithdrawal?: { __typename?: 'Withdrawal', investmentID: string, date: any, amount: number, type: WithdrawalType, spid: string } | null, availableWithdrawals: Array<{ __typename?: 'Withdrawal', investmentID: string, date: any, amount: number, type: WithdrawalType, spid: string }>, investments: Array<{ __typename?: 'Investment', _id: string, amount: number, serviceproviderName: string, serviceproviderID: string, createdAt: any, updatedAt: any, assetfinancingpool: { __typename?: 'AssetFinancingPool', status: AssetFinancingStatus, pooladdress?: string | null, assetType: AssetType, contractCID?: string | null } }> } | { __typename: 'ServiceProvider', _id: string, logo?: string | null, name: string, companytype: CompanyType, referencenumber: string, publickey: string, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null, assetfinancingpool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null }, address: { __typename?: 'Address', street: string, housenumber: string, zipcode: string, country: string, city: string }, bankaccount: { __typename?: 'BankAccount', iban: string, bic: string, verified: boolean, beneficiaryID?: string | null } } } } };

export type GetPaginatedCompaniesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AssetFinancingStatus>;
  companytype?: InputMaybe<CompanyType>;
}>;


export type GetPaginatedCompaniesQuery = { __typename?: 'Query', paginatedCompanies: { __typename?: 'CompanyConnection', edges: Array<{ __typename?: 'CompanyEdge', cursor: string, node: { __typename?: 'Customer', _id: string, companytype: CompanyType, logo?: string | null, name: string, phone: any, publickey: string, vatnumber: string } | { __typename?: 'Financier', _id: string, companytype: CompanyType, logo?: string | null, name: string, phone: any, publickey: string, vatnumber: string } | { __typename?: 'ServiceProvider', _id: string, companytype: CompanyType, logo?: string | null, name: string, phone: any, publickey: string, vatnumber: string, assetfinancingpool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null, spdetails: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedCustomersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedCustomersQuery = { __typename?: 'Query', paginatedCustomers: { __typename?: 'CustomerConnection', edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node: { __typename?: 'CustomerOnServiceProvider', _id: string, name: string, publickey: string, companytype: CompanyType, status: CustomerStatus, idFromDocumentary: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedCreditLimitRequestsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  status?: InputMaybe<CreditLimitRequestStatus>;
  customerID?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetPaginatedCreditLimitRequestsQuery = { __typename?: 'Query', paginatedCreditLimitRequests: { __typename?: 'CreditLimitRequestConnection', edges: Array<{ __typename?: 'CreditLimitRequestEdge', cursor: string, node: { __typename?: 'CreditLimitRequest', _id: string, serviceproviderID: string, customerID: string, requestedAmount: number, reasonForRequest: string, reasonForDenial?: string | null, status: CreditLimitRequestStatus, updatedAt: any, createdAt: any, serviceprovider: { __typename?: 'ServiceProvider', name: string }, customer: { __typename?: 'Customer', name: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedAssetsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  assetfinancingpoolId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  isFinanced?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPaginatedAssetsQuery = { __typename?: 'Query', paginatedAssets: { __typename?: 'AssetConnection', edges: Array<{ __typename?: 'AssetEdge', cursor: string, node: { __typename?: 'InventoryAsset', shopURL: string, isCollateral: boolean, _id: string, idFromDocumentary: string, date: any, value: number, isFinanced: boolean, financingStatus: string, type: AssetType, createdAt: any, updatedAt: any, quantity?: number | null } | { __typename?: 'ReceivableAsset', _id: string, idFromDocumentary: string, date: any, value: number, isFinanced: boolean, financingStatus: string, type: AssetType, createdAt: any, updatedAt: any, quantity?: number | null, customer: { __typename?: 'CustomerOnAsset', _id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedTokenTransactionsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TokenTransactionStatus>;
  type?: InputMaybe<TokenTransactionType>;
}>;


export type GetPaginatedTokenTransactionsQuery = { __typename?: 'Query', paginatedTokenTransactions: { __typename?: 'TokenTransactionConnection', edges: Array<{ __typename?: 'TokenTransactionEdge', cursor: string, node: { __typename?: 'TokenTransaction', _id: string, amount: number, type: TokenTransactionType, status: TokenTransactionStatus, txhash?: string | null, referencenumber?: string | null, tokentransferdate?: any | null, banktransferdate?: any | null, reasonForFailure?: string | null, createdAt: any, updatedAt: any } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedAssetFinancingRoundsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetPaginatedAssetFinancingRoundsQuery = { __typename?: 'Query', paginatedAssetFinancingRounds: { __typename?: 'AssetFinancingRoundConnection', edges: Array<{ __typename?: 'AssetFinancingRoundEdge', cursor: string, node: { __typename?: 'AssetFinancingRound', _id: string, amountFinanced: number, amountNotFinanced: number, inventoryBought?: number | null, inventorySold?: number | null, serviceproviderID: string, createdAt: any, updatedAt: any, spdetails: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedUsersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedUsersQuery = { __typename?: 'Query', paginatedUsers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'Developer', _id: string, firstname: string, lastname: string, usertype: UserType, mail: any, role: UserRole, active: boolean, allowMails: boolean } | { __typename?: 'Employee', _id: string, firstname: string, lastname: string, usertype: UserType, mail: any, role: UserRole, active: boolean, allowMails: boolean, employer: { __typename?: 'Customer', _id: string, name: string } | { __typename?: 'Financier', _id: string, name: string } | { __typename?: 'ServiceProvider', _id: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetPaginatedAssetFinancingPoolsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AssetFinancingStatus>;
  companyname?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedAssetFinancingPoolsQuery = { __typename?: 'Query', paginatedAssetFinancingPools: { __typename?: 'AssetFinancingPoolConnection', edges: Array<{ __typename?: 'AssetFinancingPoolEdge', cursor: string, node: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null, serviceproviderID: string, createdAt: any, updatedAt: any, spdetails: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetServiceProviderDetailsByIdQueryVariables = Exact<{
  serviceproviderId: Scalars['String']['input'];
}>;


export type GetServiceProviderDetailsByIdQuery = { __typename?: 'Query', getServiceProviderDetailsByID: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } };

export type GetPaginatedInvestmentsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AssetFinancingStatus>;
  companyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaginatedInvestmentsQuery = { __typename?: 'Query', paginatedInvestments: { __typename?: 'InvestmentConnection', edges: Array<{ __typename?: 'InvestmentEdge', cursor: string, node: { __typename?: 'Investment', _id: string, amount: number, serviceproviderID: string, serviceproviderName: string, financierID: string, currentNumberOfInterestWithdrawals: number, maximumNumberOfInterestWithdrawals: number, createdAt: any, updatedAt: any, assetfinancingpool: { __typename?: 'AssetFinancingPool', _id: string, contractCID?: string | null, financinglimit: number, interest: number, rewardpayoutperiod: number, status: AssetFinancingStatus, dayslocked: number, amountinvested: number, activationdate?: any | null, pooladdress?: string | null, tokenaddress?: string | null, assetType: AssetType, floor?: number | null, ceiling?: number | null, uniqueitems?: boolean | null, serviceproviderID: string, createdAt: any, updatedAt: any, spdetails: { __typename?: 'ServiceProviderDetails', _id: string, name: string, assettype?: string | null, logo?: string | null, companydetails?: { __typename?: 'CompanyDetails', industry?: string | null, description?: string | null, yearlyrevenue?: number | null, foundingyear?: number | null, webpresence?: { __typename?: 'WebPresence', website?: any | null, facebook?: any | null, twitter?: any | null, linkedin?: any | null } | null } | null } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetAssetDetailsByIdQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type GetAssetDetailsByIdQuery = { __typename?: 'Query', getAssetDetailsByID: { __typename?: 'AssetDetails', additionals: Array<{ __typename?: 'AttributePattern', key: string, value: string, type: string }>, financingDetails: Array<{ __typename?: 'FinancingDetails', isFinanced?: boolean | null, financingStatus?: string | null, createdAt: any, movementDate?: any | null, movementType?: MovementType | null, movementQuantity?: number | null }> } };

export type GetOffChainCodedTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOffChainCodedTermsQuery = { __typename?: 'Query', getOffChainCodedTerms: string };

export type CreditLimitRequestCreatedSubscriptionVariables = Exact<{
  serviceProviderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreditLimitRequestCreatedSubscription = { __typename?: 'Subscription', creditLimitRequestCreated?: { __typename?: 'CreditLimitRequest', _id: string, serviceproviderID: string, customerID: string, requestedAmount: number, reasonForRequest: string, reasonForDenial?: string | null, status: CreditLimitRequestStatus, createdAt: any, updatedAt: any, serviceprovider: { __typename?: 'ServiceProvider', name: string }, customer: { __typename?: 'Customer', name: string } } | null };

export type CreditLimitRequestEditedSubscriptionVariables = Exact<{
  serviceProviderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreditLimitRequestEditedSubscription = { __typename?: 'Subscription', creditLimitRequestEdited?: { __typename?: 'CreditLimitRequest', _id: string, serviceproviderID: string, customerID: string, requestedAmount: number, reasonForRequest: string, reasonForDenial?: string | null, status: CreditLimitRequestStatus, createdAt: any, updatedAt: any, serviceprovider: { __typename?: 'ServiceProvider', name: string }, customer: { __typename?: 'Customer', name: string } } | null };

export const CompanyDetailsFragmentDoc = gql`
    fragment CompanyDetails on Company {
  _id
  logo
  name
  companytype
  referencenumber
  address {
    street
    housenumber
    zipcode
    country
    city
  }
  bankaccount {
    iban
    bic
    verified
  }
  logo
  publickey
}
    `;
export const BankAccountFragmentDoc = gql`
    fragment BankAccount on Company {
  bankaccount {
    iban
    bic
    verified
  }
}
    `;
export const UpdatedServiceProviderFragmentDoc = gql`
    fragment UpdatedServiceProvider on ServiceProvider {
  _id
  assetfinancingpool {
    _id
  }
}
    `;
export const LogoFragmentDoc = gql`
    fragment Logo on Company {
  logo
}
    `;
export const FinancierDetailsFragmentDoc = gql`
    fragment FinancierDetails on Financier {
  _id
  totalInvestedAmount
  averageInterestRate
  currentWorthIncludingInterest
  totalInvestedAmountInclInterest
  nextWithdrawal {
    investmentID
    date
    amount
    type
    spid
  }
  availableWithdrawals {
    investmentID
    date
    amount
    type
    spid
  }
  investments {
    _id
    amount
    serviceproviderName
    serviceproviderID
    assetfinancingpool {
      status
      pooladdress
      assetType
      contractCID
    }
    createdAt
    updatedAt
  }
}
    `;
export const FinancierDetailsLiteFragmentDoc = gql`
    fragment FinancierDetailsLite on Financier {
  totalInvestedAmount
  averageInterestRate
  currentWorthIncludingInterest
  totalInvestedAmountInclInterest
}
    `;
export const ServiceProviderDataFragmentDoc = gql`
    fragment ServiceProviderData on ServiceProvider {
  name
  assetfinancingpool {
    _id
    contractCID
    financinglimit
    interest
    rewardpayoutperiod
    status
    dayslocked
    uniqueitems
    amountinvested
    activationdate
    pooladdress
    tokenaddress
    assetType
    floor
    ceiling
  }
}
    `;
export const ServiceProviderDetailsFragmentDoc = gql`
    fragment ServiceProviderDetails on ServiceProviderDetails {
  name
  assettype
  logo
  companydetails {
    industry
    description
    yearlyrevenue
    foundingyear
    webpresence {
      website
      facebook
      twitter
      linkedin
    }
  }
}
    `;
export const CompanyDetailsOnlyFragmentDoc = gql`
    fragment CompanyDetailsOnly on ServiceProvider {
  companydetails {
    industry
    description
    yearlyrevenue
    foundingyear
    webpresence {
      website
      facebook
      twitter
      linkedin
    }
  }
}
    `;
export const CompanyAddressFragmentDoc = gql`
    fragment CompanyAddress on Company {
  address {
    street
    housenumber
    zipcode
    country
    city
  }
}
    `;
export const CreditLimitRequestFragmentDoc = gql`
    fragment CreditLimitRequest on CreditLimitRequest {
  _id
  serviceproviderID
  customerID
  requestedAmount
  reasonForRequest
  reasonForDenial
  status
  updatedAt
  createdAt
  serviceprovider {
    name
  }
  customer {
    name
  }
}
    `;
export const CompanyPublicKeyFragmentDoc = gql`
    fragment CompanyPublicKey on Company {
  publickey
}
    `;
export const EmployeeDetailsFragmentDoc = gql`
    fragment EmployeeDetails on Employee {
  __typename
  _id
  active
  firstname
  lastname
  mail
  role
  usertype
  allowMails
  employer {
    __typename
    _id
    name
  }
}
    `;
export const DeveloperDetailsFragmentDoc = gql`
    fragment DeveloperDetails on Developer {
  __typename
  _id
  active
  firstname
  lastname
  mail
  role
  usertype
  allowMails
}
    `;
export const AssetFinancingPoolFragmentDoc = gql`
    fragment AssetFinancingPool on AssetFinancingPool {
  _id
  contractCID
  financinglimit
  interest
  rewardpayoutperiod
  status
  dayslocked
  amountinvested
  activationdate
  pooladdress
  tokenaddress
  assetType
  floor
  ceiling
  uniqueitems
  serviceproviderID
}
    `;
export const AfpInvestFieldsFragmentDoc = gql`
    fragment AFPInvestFields on AssetFinancingPool {
  amountinvested
  status
}
    `;
export const AssetFinancingPoolMoreFragmentDoc = gql`
    fragment AssetFinancingPoolMore on AssetFinancingPool {
  _id
  contractCID
  financinglimit
  interest
  rewardpayoutperiod
  status
  dayslocked
  amountinvested
  activationdate
  pooladdress
  tokenaddress
  assetType
  floor
  ceiling
  uniqueitems
  serviceproviderID
  spdetails {
    _id
    name
    assettype
    logo
    companydetails {
      industry
      description
      yearlyrevenue
      foundingyear
      webpresence {
        website
        facebook
        twitter
        linkedin
      }
    }
  }
  createdAt
  updatedAt
}
    `;
export const ContractAddressesFragmentDoc = gql`
    fragment ContractAddresses on AssetFinancingPool {
  pooladdress
  tokenaddress
  status
}
    `;
export const InvestmentFieldsFragmentDoc = gql`
    fragment InvestmentFields on Investment {
  serviceproviderID
  amount
}
    `;
export const CreateUserDocument = gql`
    mutation createUser($createUserInput: CreateUserInput!) {
  createUser(createUserInput: $createUserInput) {
    _id
    firstname
    lastname
    usertype
    mail
    role
    active
    ... on Employee {
      employer {
        _id
        name
      }
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      createUserInput: // value for 'createUserInput'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($companyInput: CreateCompanyInput!) {
  createCompany(companyInput: $companyInput)
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const AddInvestmentDocument = gql`
    mutation addInvestment($id: ID!, $investmentInput: InvestmentInput!) {
  addInvestment(ID: $id, investmentInput: $investmentInput) {
    serviceproviderID
    assetfinancingpoolID
    amount
    status
    totalInvestedAmount
  }
}
    `;
export type AddInvestmentMutationFn = Apollo.MutationFunction<AddInvestmentMutation, AddInvestmentMutationVariables>;

/**
 * __useAddInvestmentMutation__
 *
 * To run a mutation, you first call `useAddInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInvestmentMutation, { data, loading, error }] = useAddInvestmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      investmentInput: // value for 'investmentInput'
 *   },
 * });
 */
export function useAddInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<AddInvestmentMutation, AddInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInvestmentMutation, AddInvestmentMutationVariables>(AddInvestmentDocument, options);
      }
export type AddInvestmentMutationHookResult = ReturnType<typeof useAddInvestmentMutation>;
export type AddInvestmentMutationResult = Apollo.MutationResult<AddInvestmentMutation>;
export type AddInvestmentMutationOptions = Apollo.BaseMutationOptions<AddInvestmentMutation, AddInvestmentMutationVariables>;
export const EditUserDocument = gql`
    mutation editUser($id: ID!, $userInput: EditUserInput!) {
  editUser(ID: $id, userInput: $userInput)
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const EditPasswordDocument = gql`
    mutation editPassword($id: ID!, $passwordInput: PasswordInput!) {
  editPassword(ID: $id, passwordInput: $passwordInput)
}
    `;
export type EditPasswordMutationFn = Apollo.MutationFunction<EditPasswordMutation, EditPasswordMutationVariables>;

/**
 * __useEditPasswordMutation__
 *
 * To run a mutation, you first call `useEditPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPasswordMutation, { data, loading, error }] = useEditPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      passwordInput: // value for 'passwordInput'
 *   },
 * });
 */
export function useEditPasswordMutation(baseOptions?: Apollo.MutationHookOptions<EditPasswordMutation, EditPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPasswordMutation, EditPasswordMutationVariables>(EditPasswordDocument, options);
      }
export type EditPasswordMutationHookResult = ReturnType<typeof useEditPasswordMutation>;
export type EditPasswordMutationResult = Apollo.MutationResult<EditPasswordMutation>;
export type EditPasswordMutationOptions = Apollo.BaseMutationOptions<EditPasswordMutation, EditPasswordMutationVariables>;
export const EditCompanyDocument = gql`
    mutation editCompany($id: ID!, $companyInput: EditCompanyInput!) {
  editCompany(ID: $id, companyInput: $companyInput)
}
    `;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyInput: // value for 'companyInput'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, options);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const ChangeLogoDocument = gql`
    mutation ChangeLogo($id: ID!, $newPicture: Upload) {
  changeLogo(ID: $id, newPicture: $newPicture)
}
    `;
export type ChangeLogoMutationFn = Apollo.MutationFunction<ChangeLogoMutation, ChangeLogoMutationVariables>;

/**
 * __useChangeLogoMutation__
 *
 * To run a mutation, you first call `useChangeLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLogoMutation, { data, loading, error }] = useChangeLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPicture: // value for 'newPicture'
 *   },
 * });
 */
export function useChangeLogoMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLogoMutation, ChangeLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLogoMutation, ChangeLogoMutationVariables>(ChangeLogoDocument, options);
      }
export type ChangeLogoMutationHookResult = ReturnType<typeof useChangeLogoMutation>;
export type ChangeLogoMutationResult = Apollo.MutationResult<ChangeLogoMutation>;
export type ChangeLogoMutationOptions = Apollo.BaseMutationOptions<ChangeLogoMutation, ChangeLogoMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: ID!) {
  deleteUser(ID: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeployAssetFinancingPoolContractDocument = gql`
    mutation DeployAssetFinancingPoolContract($serviceProviderId: ID!) {
  deployAssetFinancingPoolContract(serviceProviderID: $serviceProviderId) {
    pooladdress
    tokenaddress
  }
}
    `;
export type DeployAssetFinancingPoolContractMutationFn = Apollo.MutationFunction<DeployAssetFinancingPoolContractMutation, DeployAssetFinancingPoolContractMutationVariables>;

/**
 * __useDeployAssetFinancingPoolContractMutation__
 *
 * To run a mutation, you first call `useDeployAssetFinancingPoolContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployAssetFinancingPoolContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployAssetFinancingPoolContractMutation, { data, loading, error }] = useDeployAssetFinancingPoolContractMutation({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useDeployAssetFinancingPoolContractMutation(baseOptions?: Apollo.MutationHookOptions<DeployAssetFinancingPoolContractMutation, DeployAssetFinancingPoolContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployAssetFinancingPoolContractMutation, DeployAssetFinancingPoolContractMutationVariables>(DeployAssetFinancingPoolContractDocument, options);
      }
export type DeployAssetFinancingPoolContractMutationHookResult = ReturnType<typeof useDeployAssetFinancingPoolContractMutation>;
export type DeployAssetFinancingPoolContractMutationResult = Apollo.MutationResult<DeployAssetFinancingPoolContractMutation>;
export type DeployAssetFinancingPoolContractMutationOptions = Apollo.BaseMutationOptions<DeployAssetFinancingPoolContractMutation, DeployAssetFinancingPoolContractMutationVariables>;
export const AddTokenTransactionDocument = gql`
    mutation AddTokenTransaction($id: ID!, $tokenTransactionInput: TokenTransactionInput!) {
  addTokenTransaction(ID: $id, tokenTransactionInput: $tokenTransactionInput) {
    _id
    amount
    type
    status
    txhash
    referencenumber
    tokentransferdate
    banktransferdate
    reasonForFailure
    createdAt
    updatedAt
  }
}
    `;
export type AddTokenTransactionMutationFn = Apollo.MutationFunction<AddTokenTransactionMutation, AddTokenTransactionMutationVariables>;

/**
 * __useAddTokenTransactionMutation__
 *
 * To run a mutation, you first call `useAddTokenTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTokenTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTokenTransactionMutation, { data, loading, error }] = useAddTokenTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tokenTransactionInput: // value for 'tokenTransactionInput'
 *   },
 * });
 */
export function useAddTokenTransactionMutation(baseOptions?: Apollo.MutationHookOptions<AddTokenTransactionMutation, AddTokenTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTokenTransactionMutation, AddTokenTransactionMutationVariables>(AddTokenTransactionDocument, options);
      }
export type AddTokenTransactionMutationHookResult = ReturnType<typeof useAddTokenTransactionMutation>;
export type AddTokenTransactionMutationResult = Apollo.MutationResult<AddTokenTransactionMutation>;
export type AddTokenTransactionMutationOptions = Apollo.BaseMutationOptions<AddTokenTransactionMutation, AddTokenTransactionMutationVariables>;
export const CreateCreditLimitRequestDocument = gql`
    mutation CreateCreditLimitRequest($creditLimitRequestInput: CreateCreditLimitRequestInput!) {
  createCreditLimitRequest(creditLimitRequestInput: $creditLimitRequestInput) {
    _id
    serviceproviderID
    customerID
    requestedAmount
    reasonForRequest
    reasonForDenial
    status
    updatedAt
    createdAt
    serviceprovider {
      name
    }
    customer {
      name
    }
  }
}
    `;
export type CreateCreditLimitRequestMutationFn = Apollo.MutationFunction<CreateCreditLimitRequestMutation, CreateCreditLimitRequestMutationVariables>;

/**
 * __useCreateCreditLimitRequestMutation__
 *
 * To run a mutation, you first call `useCreateCreditLimitRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditLimitRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditLimitRequestMutation, { data, loading, error }] = useCreateCreditLimitRequestMutation({
 *   variables: {
 *      creditLimitRequestInput: // value for 'creditLimitRequestInput'
 *   },
 * });
 */
export function useCreateCreditLimitRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditLimitRequestMutation, CreateCreditLimitRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditLimitRequestMutation, CreateCreditLimitRequestMutationVariables>(CreateCreditLimitRequestDocument, options);
      }
export type CreateCreditLimitRequestMutationHookResult = ReturnType<typeof useCreateCreditLimitRequestMutation>;
export type CreateCreditLimitRequestMutationResult = Apollo.MutationResult<CreateCreditLimitRequestMutation>;
export type CreateCreditLimitRequestMutationOptions = Apollo.BaseMutationOptions<CreateCreditLimitRequestMutation, CreateCreditLimitRequestMutationVariables>;
export const EditCreditLimitRequestDocument = gql`
    mutation EditCreditLimitRequest($id: ID!, $creditLimitRequestInput: EditCreditLimitRequestInput!) {
  editCreditLimitRequest(
    ID: $id
    creditLimitRequestInput: $creditLimitRequestInput
  ) {
    _id
    status
  }
}
    `;
export type EditCreditLimitRequestMutationFn = Apollo.MutationFunction<EditCreditLimitRequestMutation, EditCreditLimitRequestMutationVariables>;

/**
 * __useEditCreditLimitRequestMutation__
 *
 * To run a mutation, you first call `useEditCreditLimitRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCreditLimitRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCreditLimitRequestMutation, { data, loading, error }] = useEditCreditLimitRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      creditLimitRequestInput: // value for 'creditLimitRequestInput'
 *   },
 * });
 */
export function useEditCreditLimitRequestMutation(baseOptions?: Apollo.MutationHookOptions<EditCreditLimitRequestMutation, EditCreditLimitRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCreditLimitRequestMutation, EditCreditLimitRequestMutationVariables>(EditCreditLimitRequestDocument, options);
      }
export type EditCreditLimitRequestMutationHookResult = ReturnType<typeof useEditCreditLimitRequestMutation>;
export type EditCreditLimitRequestMutationResult = Apollo.MutationResult<EditCreditLimitRequestMutation>;
export type EditCreditLimitRequestMutationOptions = Apollo.BaseMutationOptions<EditCreditLimitRequestMutation, EditCreditLimitRequestMutationVariables>;
export const ExecuteWithdrawalOnInvestmentDocument = gql`
    mutation ExecuteWithdrawalOnInvestment($id: ID!, $withdrawalType: WithdrawalType!) {
  executeWithdrawalOnInvestment(ID: $id, withdrawalType: $withdrawalType)
}
    `;
export type ExecuteWithdrawalOnInvestmentMutationFn = Apollo.MutationFunction<ExecuteWithdrawalOnInvestmentMutation, ExecuteWithdrawalOnInvestmentMutationVariables>;

/**
 * __useExecuteWithdrawalOnInvestmentMutation__
 *
 * To run a mutation, you first call `useExecuteWithdrawalOnInvestmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteWithdrawalOnInvestmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeWithdrawalOnInvestmentMutation, { data, loading, error }] = useExecuteWithdrawalOnInvestmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withdrawalType: // value for 'withdrawalType'
 *   },
 * });
 */
export function useExecuteWithdrawalOnInvestmentMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteWithdrawalOnInvestmentMutation, ExecuteWithdrawalOnInvestmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteWithdrawalOnInvestmentMutation, ExecuteWithdrawalOnInvestmentMutationVariables>(ExecuteWithdrawalOnInvestmentDocument, options);
      }
export type ExecuteWithdrawalOnInvestmentMutationHookResult = ReturnType<typeof useExecuteWithdrawalOnInvestmentMutation>;
export type ExecuteWithdrawalOnInvestmentMutationResult = Apollo.MutationResult<ExecuteWithdrawalOnInvestmentMutation>;
export type ExecuteWithdrawalOnInvestmentMutationOptions = Apollo.BaseMutationOptions<ExecuteWithdrawalOnInvestmentMutation, ExecuteWithdrawalOnInvestmentMutationVariables>;
export const EditAssetFinancingPoolDocument = gql`
    mutation EditAssetFinancingPool($id: ID!, $assetFinancingPoolInput: EditAssetFinancingPoolInput!) {
  editAssetFinancingPool(
    ID: $id
    assetFinancingPoolInput: $assetFinancingPoolInput
  ) {
    _id
    contractCID
    financinglimit
    interest
    rewardpayoutperiod
    status
    dayslocked
    amountinvested
    activationdate
    pooladdress
    tokenaddress
    assetType
    floor
    ceiling
    serviceproviderID
    uniqueitems
  }
}
    `;
export type EditAssetFinancingPoolMutationFn = Apollo.MutationFunction<EditAssetFinancingPoolMutation, EditAssetFinancingPoolMutationVariables>;

/**
 * __useEditAssetFinancingPoolMutation__
 *
 * To run a mutation, you first call `useEditAssetFinancingPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssetFinancingPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssetFinancingPoolMutation, { data, loading, error }] = useEditAssetFinancingPoolMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetFinancingPoolInput: // value for 'assetFinancingPoolInput'
 *   },
 * });
 */
export function useEditAssetFinancingPoolMutation(baseOptions?: Apollo.MutationHookOptions<EditAssetFinancingPoolMutation, EditAssetFinancingPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAssetFinancingPoolMutation, EditAssetFinancingPoolMutationVariables>(EditAssetFinancingPoolDocument, options);
      }
export type EditAssetFinancingPoolMutationHookResult = ReturnType<typeof useEditAssetFinancingPoolMutation>;
export type EditAssetFinancingPoolMutationResult = Apollo.MutationResult<EditAssetFinancingPoolMutation>;
export type EditAssetFinancingPoolMutationOptions = Apollo.BaseMutationOptions<EditAssetFinancingPoolMutation, EditAssetFinancingPoolMutationVariables>;
export const AddAssetFinancingPoolDocument = gql`
    mutation AddAssetFinancingPool($id: ID!, $assetFinancingPoolInput: AssetFinancingPoolInput!) {
  addAssetFinancingPool(
    ID: $id
    assetFinancingPoolInput: $assetFinancingPoolInput
  ) {
    _id
    contractCID
    financinglimit
    interest
    rewardpayoutperiod
    status
    dayslocked
    amountinvested
    activationdate
    pooladdress
    tokenaddress
    assetType
    floor
    ceiling
    serviceproviderID
    uniqueitems
  }
}
    `;
export type AddAssetFinancingPoolMutationFn = Apollo.MutationFunction<AddAssetFinancingPoolMutation, AddAssetFinancingPoolMutationVariables>;

/**
 * __useAddAssetFinancingPoolMutation__
 *
 * To run a mutation, you first call `useAddAssetFinancingPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssetFinancingPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssetFinancingPoolMutation, { data, loading, error }] = useAddAssetFinancingPoolMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetFinancingPoolInput: // value for 'assetFinancingPoolInput'
 *   },
 * });
 */
export function useAddAssetFinancingPoolMutation(baseOptions?: Apollo.MutationHookOptions<AddAssetFinancingPoolMutation, AddAssetFinancingPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssetFinancingPoolMutation, AddAssetFinancingPoolMutationVariables>(AddAssetFinancingPoolDocument, options);
      }
export type AddAssetFinancingPoolMutationHookResult = ReturnType<typeof useAddAssetFinancingPoolMutation>;
export type AddAssetFinancingPoolMutationResult = Apollo.MutationResult<AddAssetFinancingPoolMutation>;
export type AddAssetFinancingPoolMutationOptions = Apollo.BaseMutationOptions<AddAssetFinancingPoolMutation, AddAssetFinancingPoolMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($id: ID!, $newPassword: String!) {
  setPassword(ID: $id, newPassword: $newPassword)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($mail: String!) {
  forgotPassword(mail: $mail)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      mail: // value for 'mail'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginUserDocument = gql`
    query loginUser($mail: String, $password: String, $token: ID) {
  loginUser(mail: $mail, password: $password, token: $token) {
    token
    user {
      __typename
      _id
      active
      firstname
      lastname
      mail
      role
      usertype
      allowMails
      ... on Employee {
        employer {
          __typename
          _id
          logo
          name
          companytype
          referencenumber
          address {
            street
            housenumber
            zipcode
            country
            city
          }
          bankaccount {
            iban
            bic
            verified
            beneficiaryID
          }
          logo
          publickey
          ... on Financier {
            ...FinancierDetails
          }
          ... on ServiceProvider {
            companydetails {
              industry
              description
              yearlyrevenue
              foundingyear
              webpresence {
                website
                facebook
                twitter
                linkedin
              }
            }
            assetfinancingpool {
              _id
              contractCID
              financinglimit
              interest
              rewardpayoutperiod
              status
              dayslocked
              amountinvested
              activationdate
              pooladdress
              tokenaddress
              assetType
              floor
              ceiling
              uniqueitems
            }
          }
        }
      }
    }
  }
}
    ${FinancierDetailsFragmentDoc}`;

/**
 * __useLoginUserQuery__
 *
 * To run a query within a React component, call `useLoginUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginUserQuery({
 *   variables: {
 *      mail: // value for 'mail'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginUserQuery(baseOptions?: Apollo.QueryHookOptions<LoginUserQuery, LoginUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginUserQuery, LoginUserQueryVariables>(LoginUserDocument, options);
      }
export function useLoginUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginUserQuery, LoginUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginUserQuery, LoginUserQueryVariables>(LoginUserDocument, options);
        }
// @ts-ignore
export function useLoginUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoginUserQuery, LoginUserQueryVariables>): Apollo.UseSuspenseQueryResult<LoginUserQuery, LoginUserQueryVariables>;
export function useLoginUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginUserQuery, LoginUserQueryVariables>): Apollo.UseSuspenseQueryResult<LoginUserQuery | undefined, LoginUserQueryVariables>;
export function useLoginUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginUserQuery, LoginUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginUserQuery, LoginUserQueryVariables>(LoginUserDocument, options);
        }
export type LoginUserQueryHookResult = ReturnType<typeof useLoginUserQuery>;
export type LoginUserLazyQueryHookResult = ReturnType<typeof useLoginUserLazyQuery>;
export type LoginUserSuspenseQueryHookResult = ReturnType<typeof useLoginUserSuspenseQuery>;
export type LoginUserQueryResult = Apollo.QueryResult<LoginUserQuery, LoginUserQueryVariables>;
export const GetPaginatedCompaniesDocument = gql`
    query getPaginatedCompanies($first: Int!, $after: String, $status: AssetFinancingStatus, $companytype: CompanyType) {
  paginatedCompanies(
    first: $first
    after: $after
    status: $status
    companytype: $companytype
  ) {
    edges {
      cursor
      node {
        _id
        companytype
        logo
        name
        phone
        publickey
        vatnumber
        ... on ServiceProvider {
          assetfinancingpool {
            _id
            contractCID
            financinglimit
            interest
            rewardpayoutperiod
            status
            dayslocked
            amountinvested
            activationdate
            pooladdress
            tokenaddress
            assetType
            floor
            ceiling
            uniqueitems
            spdetails {
              _id
              name
              assettype
              logo
              companydetails {
                industry
                description
                yearlyrevenue
                foundingyear
                webpresence {
                  website
                  facebook
                  twitter
                  linkedin
                }
              }
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      companytype: // value for 'companytype'
 *   },
 * });
 */
export function useGetPaginatedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables> & ({ variables: GetPaginatedCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
      }
export function useGetPaginatedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
        }
// @ts-ignore
export function useGetPaginatedCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>;
export function useGetPaginatedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCompaniesQuery | undefined, GetPaginatedCompaniesQueryVariables>;
export function useGetPaginatedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>(GetPaginatedCompaniesDocument, options);
        }
export type GetPaginatedCompaniesQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesQuery>;
export type GetPaginatedCompaniesLazyQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesLazyQuery>;
export type GetPaginatedCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedCompaniesSuspenseQuery>;
export type GetPaginatedCompaniesQueryResult = Apollo.QueryResult<GetPaginatedCompaniesQuery, GetPaginatedCompaniesQueryVariables>;
export const GetPaginatedCustomersDocument = gql`
    query getPaginatedCustomers($first: Int!, $after: String, $filter: String) {
  paginatedCustomers(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        _id
        name
        publickey
        companytype
        status
        idFromDocumentary
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedCustomersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCustomersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPaginatedCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables> & ({ variables: GetPaginatedCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>(GetPaginatedCustomersDocument, options);
      }
export function useGetPaginatedCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>(GetPaginatedCustomersDocument, options);
        }
// @ts-ignore
export function useGetPaginatedCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>;
export function useGetPaginatedCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCustomersQuery | undefined, GetPaginatedCustomersQueryVariables>;
export function useGetPaginatedCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>(GetPaginatedCustomersDocument, options);
        }
export type GetPaginatedCustomersQueryHookResult = ReturnType<typeof useGetPaginatedCustomersQuery>;
export type GetPaginatedCustomersLazyQueryHookResult = ReturnType<typeof useGetPaginatedCustomersLazyQuery>;
export type GetPaginatedCustomersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedCustomersSuspenseQuery>;
export type GetPaginatedCustomersQueryResult = Apollo.QueryResult<GetPaginatedCustomersQuery, GetPaginatedCustomersQueryVariables>;
export const GetPaginatedCreditLimitRequestsDocument = gql`
    query getPaginatedCreditLimitRequests($first: Int!, $status: CreditLimitRequestStatus, $customerID: ID, $after: String, $from: DateTime, $to: DateTime) {
  paginatedCreditLimitRequests(
    first: $first
    status: $status
    customerID: $customerID
    after: $after
    from: $from
    to: $to
  ) {
    edges {
      cursor
      node {
        ...CreditLimitRequest
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CreditLimitRequestFragmentDoc}`;

/**
 * __useGetPaginatedCreditLimitRequestsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCreditLimitRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCreditLimitRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCreditLimitRequestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      status: // value for 'status'
 *      customerID: // value for 'customerID'
 *      after: // value for 'after'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetPaginatedCreditLimitRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables> & ({ variables: GetPaginatedCreditLimitRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>(GetPaginatedCreditLimitRequestsDocument, options);
      }
export function useGetPaginatedCreditLimitRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>(GetPaginatedCreditLimitRequestsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedCreditLimitRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>;
export function useGetPaginatedCreditLimitRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedCreditLimitRequestsQuery | undefined, GetPaginatedCreditLimitRequestsQueryVariables>;
export function useGetPaginatedCreditLimitRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>(GetPaginatedCreditLimitRequestsDocument, options);
        }
export type GetPaginatedCreditLimitRequestsQueryHookResult = ReturnType<typeof useGetPaginatedCreditLimitRequestsQuery>;
export type GetPaginatedCreditLimitRequestsLazyQueryHookResult = ReturnType<typeof useGetPaginatedCreditLimitRequestsLazyQuery>;
export type GetPaginatedCreditLimitRequestsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedCreditLimitRequestsSuspenseQuery>;
export type GetPaginatedCreditLimitRequestsQueryResult = Apollo.QueryResult<GetPaginatedCreditLimitRequestsQuery, GetPaginatedCreditLimitRequestsQueryVariables>;
export const GetPaginatedAssetsDocument = gql`
    query getPaginatedAssets($first: Int!, $after: String, $from: DateTime, $to: DateTime, $assetfinancingpoolId: ID, $filter: String, $isFinanced: Boolean) {
  paginatedAssets(
    first: $first
    after: $after
    from: $from
    to: $to
    assetfinancingpoolID: $assetfinancingpoolId
    filter: $filter
    isFinanced: $isFinanced
  ) {
    edges {
      cursor
      node {
        _id
        idFromDocumentary
        date
        value
        isFinanced
        financingStatus
        type
        createdAt
        updatedAt
        quantity
        ... on ReceivableAsset {
          customer {
            _id
            name
          }
        }
        ... on InventoryAsset {
          shopURL
          isCollateral
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedAssetsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAssetsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      assetfinancingpoolId: // value for 'assetfinancingpoolId'
 *      filter: // value for 'filter'
 *      isFinanced: // value for 'isFinanced'
 *   },
 * });
 */
export function useGetPaginatedAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables> & ({ variables: GetPaginatedAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>(GetPaginatedAssetsDocument, options);
      }
export function useGetPaginatedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>(GetPaginatedAssetsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>;
export function useGetPaginatedAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetsQuery | undefined, GetPaginatedAssetsQueryVariables>;
export function useGetPaginatedAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>(GetPaginatedAssetsDocument, options);
        }
export type GetPaginatedAssetsQueryHookResult = ReturnType<typeof useGetPaginatedAssetsQuery>;
export type GetPaginatedAssetsLazyQueryHookResult = ReturnType<typeof useGetPaginatedAssetsLazyQuery>;
export type GetPaginatedAssetsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedAssetsSuspenseQuery>;
export type GetPaginatedAssetsQueryResult = Apollo.QueryResult<GetPaginatedAssetsQuery, GetPaginatedAssetsQueryVariables>;
export const GetPaginatedTokenTransactionsDocument = gql`
    query getPaginatedTokenTransactions($first: Int!, $after: String, $status: TokenTransactionStatus, $type: TokenTransactionType) {
  paginatedTokenTransactions(
    first: $first
    after: $after
    status: $status
    type: $type
  ) {
    edges {
      node {
        _id
        amount
        type
        status
        txhash
        referencenumber
        tokentransferdate
        banktransferdate
        reasonForFailure
        createdAt
        updatedAt
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedTokenTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedTokenTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedTokenTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedTokenTransactionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPaginatedTokenTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables> & ({ variables: GetPaginatedTokenTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>(GetPaginatedTokenTransactionsDocument, options);
      }
export function useGetPaginatedTokenTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>(GetPaginatedTokenTransactionsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedTokenTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>;
export function useGetPaginatedTokenTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedTokenTransactionsQuery | undefined, GetPaginatedTokenTransactionsQueryVariables>;
export function useGetPaginatedTokenTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>(GetPaginatedTokenTransactionsDocument, options);
        }
export type GetPaginatedTokenTransactionsQueryHookResult = ReturnType<typeof useGetPaginatedTokenTransactionsQuery>;
export type GetPaginatedTokenTransactionsLazyQueryHookResult = ReturnType<typeof useGetPaginatedTokenTransactionsLazyQuery>;
export type GetPaginatedTokenTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedTokenTransactionsSuspenseQuery>;
export type GetPaginatedTokenTransactionsQueryResult = Apollo.QueryResult<GetPaginatedTokenTransactionsQuery, GetPaginatedTokenTransactionsQueryVariables>;
export const GetPaginatedAssetFinancingRoundsDocument = gql`
    query getPaginatedAssetFinancingRounds($first: Int!, $after: String, $poolId: ID) {
  paginatedAssetFinancingRounds(first: $first, after: $after, poolID: $poolId) {
    edges {
      node {
        _id
        amountFinanced
        amountNotFinanced
        inventoryBought
        inventorySold
        serviceproviderID
        spdetails {
          _id
          name
          assettype
          logo
          companydetails {
            industry
            description
            yearlyrevenue
            foundingyear
            webpresence {
              website
              facebook
              twitter
              linkedin
            }
          }
        }
        createdAt
        updatedAt
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedAssetFinancingRoundsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAssetFinancingRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAssetFinancingRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAssetFinancingRoundsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      poolId: // value for 'poolId'
 *   },
 * });
 */
export function useGetPaginatedAssetFinancingRoundsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables> & ({ variables: GetPaginatedAssetFinancingRoundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>(GetPaginatedAssetFinancingRoundsDocument, options);
      }
export function useGetPaginatedAssetFinancingRoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>(GetPaginatedAssetFinancingRoundsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedAssetFinancingRoundsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>;
export function useGetPaginatedAssetFinancingRoundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetFinancingRoundsQuery | undefined, GetPaginatedAssetFinancingRoundsQueryVariables>;
export function useGetPaginatedAssetFinancingRoundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>(GetPaginatedAssetFinancingRoundsDocument, options);
        }
export type GetPaginatedAssetFinancingRoundsQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingRoundsQuery>;
export type GetPaginatedAssetFinancingRoundsLazyQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingRoundsLazyQuery>;
export type GetPaginatedAssetFinancingRoundsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingRoundsSuspenseQuery>;
export type GetPaginatedAssetFinancingRoundsQueryResult = Apollo.QueryResult<GetPaginatedAssetFinancingRoundsQuery, GetPaginatedAssetFinancingRoundsQueryVariables>;
export const GetPaginatedUsersDocument = gql`
    query getPaginatedUsers($first: Int!, $after: String, $filter: String) {
  paginatedUsers(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        _id
        firstname
        lastname
        usertype
        mail
        role
        active
        allowMails
        ... on Employee {
          employer {
            _id
            name
          }
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedUsersQuery__
 *
 * To run a query within a React component, call `useGetPaginatedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPaginatedUsersQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables> & ({ variables: GetPaginatedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>(GetPaginatedUsersDocument, options);
      }
export function useGetPaginatedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>(GetPaginatedUsersDocument, options);
        }
// @ts-ignore
export function useGetPaginatedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>;
export function useGetPaginatedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedUsersQuery | undefined, GetPaginatedUsersQueryVariables>;
export function useGetPaginatedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>(GetPaginatedUsersDocument, options);
        }
export type GetPaginatedUsersQueryHookResult = ReturnType<typeof useGetPaginatedUsersQuery>;
export type GetPaginatedUsersLazyQueryHookResult = ReturnType<typeof useGetPaginatedUsersLazyQuery>;
export type GetPaginatedUsersSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedUsersSuspenseQuery>;
export type GetPaginatedUsersQueryResult = Apollo.QueryResult<GetPaginatedUsersQuery, GetPaginatedUsersQueryVariables>;
export const GetPaginatedAssetFinancingPoolsDocument = gql`
    query getPaginatedAssetFinancingPools($first: Int!, $after: String, $status: AssetFinancingStatus, $companyname: String) {
  paginatedAssetFinancingPools(
    first: $first
    after: $after
    status: $status
    companyname: $companyname
  ) {
    edges {
      node {
        _id
        contractCID
        financinglimit
        interest
        rewardpayoutperiod
        status
        dayslocked
        amountinvested
        activationdate
        pooladdress
        tokenaddress
        assetType
        floor
        ceiling
        uniqueitems
        serviceproviderID
        spdetails {
          _id
          name
          assettype
          logo
          companydetails {
            industry
            description
            yearlyrevenue
            foundingyear
            webpresence {
              website
              facebook
              twitter
              linkedin
            }
          }
        }
        createdAt
        updatedAt
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedAssetFinancingPoolsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedAssetFinancingPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedAssetFinancingPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedAssetFinancingPoolsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      companyname: // value for 'companyname'
 *   },
 * });
 */
export function useGetPaginatedAssetFinancingPoolsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables> & ({ variables: GetPaginatedAssetFinancingPoolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>(GetPaginatedAssetFinancingPoolsDocument, options);
      }
export function useGetPaginatedAssetFinancingPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>(GetPaginatedAssetFinancingPoolsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedAssetFinancingPoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>;
export function useGetPaginatedAssetFinancingPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedAssetFinancingPoolsQuery | undefined, GetPaginatedAssetFinancingPoolsQueryVariables>;
export function useGetPaginatedAssetFinancingPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>(GetPaginatedAssetFinancingPoolsDocument, options);
        }
export type GetPaginatedAssetFinancingPoolsQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingPoolsQuery>;
export type GetPaginatedAssetFinancingPoolsLazyQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingPoolsLazyQuery>;
export type GetPaginatedAssetFinancingPoolsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedAssetFinancingPoolsSuspenseQuery>;
export type GetPaginatedAssetFinancingPoolsQueryResult = Apollo.QueryResult<GetPaginatedAssetFinancingPoolsQuery, GetPaginatedAssetFinancingPoolsQueryVariables>;
export const GetServiceProviderDetailsByIdDocument = gql`
    query getServiceProviderDetailsByID($serviceproviderId: String!) {
  getServiceProviderDetailsByID(serviceproviderID: $serviceproviderId) {
    _id
    name
    assettype
    logo
    companydetails {
      industry
      description
      yearlyrevenue
      foundingyear
      webpresence {
        website
        facebook
        twitter
        linkedin
      }
    }
  }
}
    `;

/**
 * __useGetServiceProviderDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetServiceProviderDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceProviderDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceProviderDetailsByIdQuery({
 *   variables: {
 *      serviceproviderId: // value for 'serviceproviderId'
 *   },
 * });
 */
export function useGetServiceProviderDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables> & ({ variables: GetServiceProviderDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>(GetServiceProviderDetailsByIdDocument, options);
      }
export function useGetServiceProviderDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>(GetServiceProviderDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetServiceProviderDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>;
export function useGetServiceProviderDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceProviderDetailsByIdQuery | undefined, GetServiceProviderDetailsByIdQueryVariables>;
export function useGetServiceProviderDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>(GetServiceProviderDetailsByIdDocument, options);
        }
export type GetServiceProviderDetailsByIdQueryHookResult = ReturnType<typeof useGetServiceProviderDetailsByIdQuery>;
export type GetServiceProviderDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetServiceProviderDetailsByIdLazyQuery>;
export type GetServiceProviderDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetServiceProviderDetailsByIdSuspenseQuery>;
export type GetServiceProviderDetailsByIdQueryResult = Apollo.QueryResult<GetServiceProviderDetailsByIdQuery, GetServiceProviderDetailsByIdQueryVariables>;
export const GetPaginatedInvestmentsDocument = gql`
    query getPaginatedInvestments($first: Int!, $after: String, $status: AssetFinancingStatus, $companyName: String) {
  paginatedInvestments(
    first: $first
    after: $after
    status: $status
    companyName: $companyName
  ) {
    edges {
      node {
        _id
        amount
        serviceproviderID
        serviceproviderName
        financierID
        currentNumberOfInterestWithdrawals
        maximumNumberOfInterestWithdrawals
        assetfinancingpool {
          _id
          contractCID
          financinglimit
          interest
          rewardpayoutperiod
          status
          dayslocked
          amountinvested
          activationdate
          pooladdress
          tokenaddress
          assetType
          floor
          ceiling
          uniqueitems
          serviceproviderID
          spdetails {
            _id
            name
            assettype
            logo
            companydetails {
              industry
              description
              yearlyrevenue
              foundingyear
              webpresence {
                website
                facebook
                twitter
                linkedin
              }
            }
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetPaginatedInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedInvestmentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */
export function useGetPaginatedInvestmentsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables> & ({ variables: GetPaginatedInvestmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>(GetPaginatedInvestmentsDocument, options);
      }
export function useGetPaginatedInvestmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>(GetPaginatedInvestmentsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedInvestmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>;
export function useGetPaginatedInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedInvestmentsQuery | undefined, GetPaginatedInvestmentsQueryVariables>;
export function useGetPaginatedInvestmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>(GetPaginatedInvestmentsDocument, options);
        }
export type GetPaginatedInvestmentsQueryHookResult = ReturnType<typeof useGetPaginatedInvestmentsQuery>;
export type GetPaginatedInvestmentsLazyQueryHookResult = ReturnType<typeof useGetPaginatedInvestmentsLazyQuery>;
export type GetPaginatedInvestmentsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedInvestmentsSuspenseQuery>;
export type GetPaginatedInvestmentsQueryResult = Apollo.QueryResult<GetPaginatedInvestmentsQuery, GetPaginatedInvestmentsQueryVariables>;
export const GetAssetDetailsByIdDocument = gql`
    query GetAssetDetailsByID($assetId: ID!) {
  getAssetDetailsByID(assetID: $assetId) {
    additionals {
      key
      value
      type
    }
    financingDetails {
      isFinanced
      financingStatus
      createdAt
      movementDate
      movementType
      movementQuantity
    }
  }
}
    `;

/**
 * __useGetAssetDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetAssetDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetDetailsByIdQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useGetAssetDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables> & ({ variables: GetAssetDetailsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>(GetAssetDetailsByIdDocument, options);
      }
export function useGetAssetDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>(GetAssetDetailsByIdDocument, options);
        }
// @ts-ignore
export function useGetAssetDetailsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>;
export function useGetAssetDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssetDetailsByIdQuery | undefined, GetAssetDetailsByIdQueryVariables>;
export function useGetAssetDetailsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>(GetAssetDetailsByIdDocument, options);
        }
export type GetAssetDetailsByIdQueryHookResult = ReturnType<typeof useGetAssetDetailsByIdQuery>;
export type GetAssetDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetAssetDetailsByIdLazyQuery>;
export type GetAssetDetailsByIdSuspenseQueryHookResult = ReturnType<typeof useGetAssetDetailsByIdSuspenseQuery>;
export type GetAssetDetailsByIdQueryResult = Apollo.QueryResult<GetAssetDetailsByIdQuery, GetAssetDetailsByIdQueryVariables>;
export const GetOffChainCodedTermsDocument = gql`
    query GetOffChainCodedTerms {
  getOffChainCodedTerms
}
    `;

/**
 * __useGetOffChainCodedTermsQuery__
 *
 * To run a query within a React component, call `useGetOffChainCodedTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffChainCodedTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffChainCodedTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOffChainCodedTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>(GetOffChainCodedTermsDocument, options);
      }
export function useGetOffChainCodedTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>(GetOffChainCodedTermsDocument, options);
        }
// @ts-ignore
export function useGetOffChainCodedTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>;
export function useGetOffChainCodedTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOffChainCodedTermsQuery | undefined, GetOffChainCodedTermsQueryVariables>;
export function useGetOffChainCodedTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>(GetOffChainCodedTermsDocument, options);
        }
export type GetOffChainCodedTermsQueryHookResult = ReturnType<typeof useGetOffChainCodedTermsQuery>;
export type GetOffChainCodedTermsLazyQueryHookResult = ReturnType<typeof useGetOffChainCodedTermsLazyQuery>;
export type GetOffChainCodedTermsSuspenseQueryHookResult = ReturnType<typeof useGetOffChainCodedTermsSuspenseQuery>;
export type GetOffChainCodedTermsQueryResult = Apollo.QueryResult<GetOffChainCodedTermsQuery, GetOffChainCodedTermsQueryVariables>;
export const CreditLimitRequestCreatedDocument = gql`
    subscription CreditLimitRequestCreated($serviceProviderId: ID) {
  creditLimitRequestCreated(serviceProviderId: $serviceProviderId) {
    _id
    serviceproviderID
    customerID
    requestedAmount
    reasonForRequest
    reasonForDenial
    status
    serviceprovider {
      name
    }
    customer {
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreditLimitRequestCreatedSubscription__
 *
 * To run a query within a React component, call `useCreditLimitRequestCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreditLimitRequestCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditLimitRequestCreatedSubscription({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useCreditLimitRequestCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreditLimitRequestCreatedSubscription, CreditLimitRequestCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreditLimitRequestCreatedSubscription, CreditLimitRequestCreatedSubscriptionVariables>(CreditLimitRequestCreatedDocument, options);
      }
export type CreditLimitRequestCreatedSubscriptionHookResult = ReturnType<typeof useCreditLimitRequestCreatedSubscription>;
export type CreditLimitRequestCreatedSubscriptionResult = Apollo.SubscriptionResult<CreditLimitRequestCreatedSubscription>;
export const CreditLimitRequestEditedDocument = gql`
    subscription CreditLimitRequestEdited($serviceProviderId: ID) {
  creditLimitRequestEdited(serviceProviderId: $serviceProviderId) {
    _id
    serviceproviderID
    customerID
    requestedAmount
    reasonForRequest
    reasonForDenial
    status
    serviceprovider {
      name
    }
    customer {
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreditLimitRequestEditedSubscription__
 *
 * To run a query within a React component, call `useCreditLimitRequestEditedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreditLimitRequestEditedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditLimitRequestEditedSubscription({
 *   variables: {
 *      serviceProviderId: // value for 'serviceProviderId'
 *   },
 * });
 */
export function useCreditLimitRequestEditedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreditLimitRequestEditedSubscription, CreditLimitRequestEditedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreditLimitRequestEditedSubscription, CreditLimitRequestEditedSubscriptionVariables>(CreditLimitRequestEditedDocument, options);
      }
export type CreditLimitRequestEditedSubscriptionHookResult = ReturnType<typeof useCreditLimitRequestEditedSubscription>;
export type CreditLimitRequestEditedSubscriptionResult = Apollo.SubscriptionResult<CreditLimitRequestEditedSubscription>;